import { Typography } from "@mui/material";
import "../css/card.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

const Card = () => {

  const [cardData, setCardData] = useState([])

  useEffect(() => {
    axios
      .get("http://api.meddaily.in/get_product",
        { headers: { 'token': sessionStorage.getItem('token') } })
      .then((res) => {
        // console.log(res.data);
        setCardData(res.data.product);
      })
      .catch(error => console.error('Error fetching banner data:', error));
  }, []);

  return (
    <>
      {cardData.map((item) => (
        // item.distributors[0]?.price != null &&
        <div className="card">
          <Typography variant="h6">
            {item.name} <br></br>
          </Typography>
          <Typography mt={4}>{item.distributor_name}</Typography>

          <Typography mt={3} mb={2} variant="h6">
            Best Price* <span style={{ color: "#30d5c8" }}>₹ {item.price.upDatePrice} </span>
          </Typography>

          <Link to="/ordersummary">
            {" "}
            <button className="buy-now-btn"> Buy Now</button>
          </Link>
        </div>
      ))}
    </>
  );
};

export default Card;
